import { useState, useEffect } from 'react'
import { getResignAPI } from '../services/resign'

function UseResignOption() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getResignAPI()
      if (!result) return

      const newData = result.result.map((d, i) => {
        return { value: d.type_resign, label: d.type_resign, id: d.id }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseResignOption
 